import 'mapbox-gl-leaflet'; // has to be imported one time here, so it is available in the project
import './app/plugins/chart-plugins'; // Adjust path as needed
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// chart plugins
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
